'use client';

import { ErrorView } from '@/pages/admin-panel/succession-coverage/components/error-view';
import { useSuccessionCoverageBundle } from '@/pages/admin-panel/succession-coverage/i18n';

const RouteError = ({ reset }: { error: Error; reset: () => void }) => {
  useSuccessionCoverageBundle();

  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-p-8">
      <ErrorView onRetry={reset} isSmall />
    </div>
  );
};

export default RouteError;
